module.exports = __webpack_public_path__ + "static/media/party-m.01bf56a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Services/party-m.jpg
// module id = 85
// module chunks = 0